import React from 'react';
import IProdukt from '../../interfaces/IProdukt';
import { filterToLabel } from '../../utils/FilterHelper';
import Select from 'react-select';
import { getHexByColorName } from '../../utils/ColorManager';

type Props = {
    filterType: string;
    product: IProdukt;
    value: any;
    onChange?: (data: any) => void;
}

export default (props: Props) => {
    const { product, filterType, value, onChange } = props;
    const filterName = filterType.charAt(0).toUpperCase() + filterType.slice(1);

    let filter;
    for (const f of product.filters) {
        if (f.typ === filterType) {
            filter = f;
        }
    }

    const werte = filter.wert.split("|").map(value => ({value, label: value}));
    const [defaultValue, setDefaultValue] = React.useState<number>();

    React.useEffect(() => {
        let found = false;
        
        werte.forEach((wert, key) => {
            if (wert.value === value) {
                found = true;
                setDefaultValue(key);
            }
        });
        if (!found) {
            setDefaultValue(0);
            onChange(werte[0].value);
        }
    }, [product.filters]);
    


    const onSelect = (e) => {
        onChange(e.value);
    }

    const dot = (color = '#ccc') => ({
        alignItems: 'center',
        display: 'flex',
      
        ':before': {
          backgroundColor: color,
          borderRadius: 10,
          content: '" "',
          display: 'block',
          marginRight: 8,
          height: 15,
          width: 15,
        },
      });
      
      const colourStyles = {
        control: (styles, state) => ({ ...styles, backgroundColor: 'white', border: 0, borderBottom: "1px solid #1D4A68", borderRadius: 0, '&:hover': { borderColor: "#1D4A68"}, boxShadow: state.isFocused ? "0 0 0 0.125em rgba(0, 158, 224, 0.25)" : "" }),
        indicatorsContainer: styles => ({display: "none"}),
        indicatorsSeparator: styles => ({display: "none"}),
        menu: styles => ({ ...styles, zIndex: 9550}),
        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = getHexByColorName(data.value);
          return {
            ...styles,
            ...dot(color.color),
            cursor: isDisabled ? 'not-allowed' : 'default',
      
            ':active': {
              ...styles[':active'],
              backgroundColor: !isDisabled && (isSelected ? data.color : "grey"),
            },
          };
        },
        input: styles => ({ ...styles, ...dot() }),
        placeholder: styles => ({ ...styles, ...dot() }),
        singleValue: (styles, { data }) => ({ ...styles, ...dot(getHexByColorName(data.value).color) }),
      };

    return <div className="field  is-horizontal">
        <div className="field-label is-normal">
            <label className="label">{filterToLabel(filterName)}</label>
        </div>
        <div className="field-body">
            <div className="field">
                <div className="control">
                    <div className="select is-fullwidth">
                    {defaultValue != undefined && <Select
                        defaultValue={werte[defaultValue]}
                        options={werte}
                        styles={colourStyles}
                        onChange={onSelect}
                    />}

                    {/* <select name={filterName} onChange={onSelect} value={defaultValue }>
                        {werte.map((option, optionKey) => {
                            return <option key={optionKey} value={option} >{option}</option>
                        })}
                    </select> */}
                    </div>
                </div>
            </div>
        </div>
    </div>;
}